export function bytesToMb(size: number | string): string {
  const b = typeof size === 'string' ? parseFloat(size) : size;
  const mb = b / (1024 * 1024);
  return mb.toFixed(2);
}
